import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TurnCallsIntoContent = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 24 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 24 24`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          d="M17 10C17 9.44772 17.4477 9 18 9H22C22.5523 9 23 9.44772 23 10V14C23 14.5523 22.5523 15 22 15H18C17.4477 15 17 14.5523 17 14V10Z"
          fill="#FF6B00"
        />
        <path
          d="M17 2C17 1.44772 17.4477 1 18 1H22C22.5523 1 23 1.44772 23 2V6C23 6.55228 22.5523 7 22 7H18C17.4477 7 17 6.55228 17 6V2Z"
          fill="#FF6B00"
        />
        <path
          d="M1 2C1 1.44772 1.44772 1 2 1H14C14.5523 1 15 1.44772 15 2V14C15 14.5523 14.5523 15 14 15H2C1.44772 15 1 14.5523 1 14V2Z"
          fill="#027D00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.96078 9.86023C3.37618 7.0294 3.18056 5.29649 3.31445 4.4229C3.41771 3.74914 4.24078 2.91321 4.9975 2.49832C5.37207 2.29295 5.79582 2.50493 5.98467 2.88811C6.25229 3.43111 6.52164 4.00399 6.72607 4.44742C6.88093 4.78335 6.8299 5.17459 6.61697 5.47707C6.35949 5.84284 6.17933 6.14473 6.06086 6.36981C5.93316 6.6124 5.96085 6.8962 6.10646 7.12848C6.34775 7.51337 6.76663 8.1376 7.26294 8.69073C7.83092 9.29157 8.40108 9.7394 8.74921 9.99101C8.96222 10.145 9.23163 10.1888 9.47343 10.0858C9.70875 9.98551 10.03 9.82733 10.4245 9.59331C10.7426 9.4046 11.1367 9.38421 11.4595 9.56478C11.8857 9.80314 12.4358 10.1163 12.9563 10.4254C13.3236 10.6436 13.5019 11.0825 13.268 11.44C12.7954 12.1621 11.8979 12.9175 11.2181 12.9679C10.3429 13.0329 8.64821 12.7079 6.05824 9.96417C6.05787 9.96377 6.0569 9.96364 6.05637 9.96371C6.05583 9.96379 6.05572 9.96354 6.05535 9.96314C6.02348 9.92868 5.99196 9.89437 5.96078 9.86023Z"
          fill="white"
        />
        <g filter="url(#filter0_b_2620_22134)">
          <path
            d="M19.6288 22.9478C19.8227 23.1176 20.1263 22.9798 20.1263 22.7221L20.1263 17.1289C20.1263 16.5777 19.6804 16.1305 19.1293 16.1289L13.3545 16.1118C13.0822 16.111 12.9498 16.4442 13.1484 16.6306L14.4919 17.8912C11.4394 21.565 6.9295 18.5285 5.57873 15.5055C5.11155 21.5594 12.7336 26.4064 18.0483 21.5648L19.6288 22.9478Z"
            fill="url(#paint0_linear_2620_22134)"
          />
          <path
            d="M14.6842 18.0509L14.8346 17.8699L14.6629 17.7088L13.3194 16.4483C13.3084 16.4379 13.3051 16.4292 13.3038 16.4227C13.3023 16.4147 13.3028 16.4042 13.3072 16.3933C13.3115 16.3824 13.3182 16.3744 13.3249 16.3697C13.3303 16.3658 13.3386 16.3617 13.3538 16.3618L19.1285 16.3789C19.5419 16.3801 19.8763 16.7155 19.8763 17.1289L19.8763 22.7221C19.8763 22.765 19.8257 22.788 19.7934 22.7597L18.2129 21.3767L18.0449 21.2297L17.8799 21.38C15.3102 23.7209 12.1936 23.7198 9.76456 22.4012C7.59513 21.2236 5.9922 19.0051 5.82306 16.4782C6.62225 17.7275 7.88662 18.8691 9.30355 19.4415C10.1784 19.7948 11.1216 19.9351 12.0532 19.738C12.9874 19.5403 13.8892 19.0077 14.6842 18.0509Z"
            stroke="url(#paint1_linear_2620_22134)"
            strokeOpacity="0.6"
            strokeWidth="0.5"
          />
        </g>
        <defs>
          <filter
            id="filter0_b_2620_22134"
            x="2.55823"
            y="12.5059"
            width="20.5681"
            height="14.0342"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="1.5" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2620_22134" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2620_22134" result="shape" />
          </filter>
          <linearGradient
            id="paint0_linear_2620_22134"
            x1="10"
            y1="18.5"
            x2="18"
            y2="17.5"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#027D00" />
            <stop offset="1" stopColor="#FF6B00" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_2620_22134"
            x1="11.9845"
            y1="14.5538"
            x2="11.6675"
            y2="18.6176"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default TurnCallsIntoContent
